import { Icon } from "design-react-kit";
import moment from "moment/moment";
import React from "react";
import { useTranslate } from "react-admin";
import truncate from "truncate-html";
import "./HomeSlider.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";

const HomeSlider = ({ slides }) => {
  const translate = useTranslate();
  const dateFormat = translate("website.date.format.short");

  const getCategory = ({ tree }) => tree?.split("/")?.[1] || "";

  const getDate = ({ published }) => moment(published).format(dateFormat);

  const getLink = ({ content_type, uuid }) => `/${content_type}?uuid=${uuid}`;

  if (!Array.isArray(slides) || slides.length === 0) {
    return null;
  }

  return (
    <div className="home-slider">
      <Swiper
        modules={[Navigation, Pagination]}
        navigation
        pagination={{ clickable: true }}
        loop={false}
        slidesPerView={1}
        observer={false}
        observeParents={false}
      >
        {slides.map((slide, x) => (
          <SwiperSlide key={x}>
            <div className="home-slider__slide">
              <div className="home-slider__slide__media">
                <img
                  alt="placeholder"
                  className="home-slider__slide__image"
                  src="/website/placeholder.png"
                />
              </div>

              <div className="home-slider__slide__data">
                <div className="home-slider__slide__date">
                  <span className="home-slider__slide__date-label">
                    {getCategory(slide)}
                  </span>
                  <span className="home-slider__slide__date-value">
                    {getDate(slide)}
                  </span>
                </div>

                <div className="home-slider__slide__title">{slide.name}</div>

                <div
                  className="home-slider__slide__description"
                  dangerouslySetInnerHTML={{
                    __html: truncate(slide.description, 32, {
                      byWords: true,
                    }),
                  }}
                />

                <div className="home-slider__slide__tags">
                  {(slide.tags || []).map((tag, y) => (
                    <div className="home-slider__slide__tag" key={y}>
                      {tag}
                    </div>
                  ))}
                </div>

                <div className="home-slider__slide__link">
                  <a href={getLink(slide)}>
                    <span>LEGGI DI PIÙ</span>
                    <Icon color="primary" icon="it-arrow-right" size="sm" />
                  </a>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HomeSlider;
